import React, { useEffect, useState } from 'react'
import { it } from 'date-fns/locale'
import { CalendarIcon } from 'lucide-react'
import { DateRange } from 'react-day-picker'

import { dayjs } from '@/lib/dayjs.ts'
import { cn } from '@/lib/utils.ts'
import { Calendar } from '@/components/ui/calendar.tsx'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover.tsx'

const date = {
  from: new Date(),
  to: new Date(),
}

export const DatePickerFilterInput: React.FC<{
  value?: DateRange
  onSelect?: (dateRange: DateRange) => void
}> = ({ value, onSelect }) => {
  const [localValue, setLocalValue] = useState<DateRange | undefined>()
  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handleSelect = (dateRange?: DateRange) => {
    setLocalValue(dateRange)
    if (dateRange?.from && dateRange?.to) {
      onSelect?.(dateRange)
    }
  }

  return (
    <div className={cn('grid gap-2')}>
      <Popover defaultOpen={true}>
        <PopoverTrigger>
          <div className="flex items-center justify-start gap-x-1 text-left text-sm font-normal">
            <CalendarIcon className="size-4" />
            {date?.from ? (
              date.to ? (
                <>
                  {dayjs(date.from).format('DD/MM/YYYY')} -{' '}
                  {dayjs(date.to).format('DD/MM/YYYY')}
                </>
              ) : (
                dayjs(date.from).format('LLL dd, y')
              )
            ) : (
              <span>Pick a date</span>
            )}
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={localValue?.from}
            selected={localValue}
            // onSelect={setDate}
            locale={it}
            onSelect={handleSelect}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
